import { useEffect, useRef, useState } from 'react';
import { createEventStream, type EventStreamOptions, type StreamStatus } from './eventStream';

/** Mở luồng SSE khi `enabled`, đóng khi unmount. Trả về trạng thái kết nối để hiển thị "mất kết nối". */
export function useEventStream(options: EventStreamOptions, enabled = true): StreamStatus {
  const [status, setStatus] = useState<StreamStatus>('idle');
  const ref = useRef(options);
  ref.current = options;

  useEffect(() => {
    if (!enabled) return;
    const stream = createEventStream({
      ...ref.current,
      getToken: () => ref.current.getToken(),
      onMessage: (m) => ref.current.onMessage(m),
      onReconnected: () => ref.current.onReconnected?.(),
      onUnauthorized: ref.current.onUnauthorized ? () => ref.current.onUnauthorized!() : undefined,
      onStatus: (s) => { setStatus(s); ref.current.onStatus?.(s); },
    });
    stream.start();
    return () => stream.stop();
  }, [enabled, options.url]);

  return status;
}
